export enum ResponsibleForConnection {
    Customer = 0,
    Partner = 1,
}
